import { DependenciesInjection } from "app/di/DependencyInjection";
import { AuthenticationImpl } from "features/login/data/AuthenticationImpl";
import { LoginViewModel } from "features/login/presentation/viewModel/LoginViewModel";
import { AuthenticationToken } from "./AuthenticationToken";
import { IAuthenticationRepository } from "../domain/repositories/IAuthenticationRepository";
import { AuthenticationUseCase } from "../domain/useCases/AuthenticationUseCase";

export class AuthenticationInjection {
  static injectAuthentication() {
    DependenciesInjection.register<IAuthenticationRepository>(
      AuthenticationToken.IAuthenticationRepository,
      AuthenticationImpl,
      "otherRepo",
    );

    DependenciesInjection.register<LoginViewModel>(
      AuthenticationToken.LoginViewModel,
      LoginViewModel,
      "viewModel",
    );

    DependenciesInjection.register<AuthenticationUseCase>(
      AuthenticationToken.AuthenticationUseCase,
      AuthenticationUseCase,
      "otherRepo",
    );
  }

  static getAuthenticationRepo() {
    return DependenciesInjection.getRepo<IAuthenticationRepository>(
      AuthenticationToken.IAuthenticationRepository,
    );
  }

  static getAuthenticationUseCase() {
    return DependenciesInjection.getRepo<AuthenticationUseCase>(
      AuthenticationToken.AuthenticationUseCase,
    );
  }
}
